import {jsx, ParamComponent} from 'panel';

type PanelComponentOptions = {
  jsxFactory: TODO;
  attrs?: Record<string, any>;
  props?: Record<string, any>;
  params?: Record<string, any>;
  on?: Record<string, any>;
  hook?: Record<string, any>;

  requiredProps?: string[];
  requiredParams?: string[];
};

export type ReactSnabbdomRendererJsxProps = {
  params: {
    targetPanelComponent?: PanelComponentOptions;
  };
};

// This component's only purpose is to render a target Panel component inside itself and be wrapped by wc2react.
// This allows the target Panel component to avoid wc2react's rendering quirks as it is rendered inside this component instead using snabbdom
export class ReactSnabbdomRenderer extends ParamComponent<ReactSnabbdomRendererJsxProps['params']> {
  get config() {
    return {
      template: () => this.renderTemplate(),
      params: {
        targetPanelComponent: {
          type: Object,
        },
      },
    };
  }

  renderTemplate() {
    if (this.params.targetPanelComponent) {
      const requiredProps = this.params.targetPanelComponent.requiredProps ?? [];
      const hasRequiredProps = requiredProps.every((requiredProp) => {
        // we actually want to specifically check null or undefined
        // eslint-disable-next-line eqeqeq
        return this.params.targetPanelComponent.props?.[requiredProp] != null;
      });
      const requiredParams = this.params.targetPanelComponent.requiredParams ?? [];
      const hasRequiredParams = requiredParams.every((requiredParam) => {
        // we actually want to specifically check null or undefined
        // eslint-disable-next-line eqeqeq
        return this.params.targetPanelComponent.params?.[requiredParam] != null;
      });
      if (hasRequiredProps && hasRequiredParams) {
        const JsxFactory = this.params.targetPanelComponent.jsxFactory;
        const jp = this.params.targetPanelComponent;
        return <JsxFactory attrs={jp.attrs} props={jp.props} params={jp.params} on={jp.on} hook={jp.hook} />;
      }
    }
    // note: don't return "null" or empty fragment in component template, Panel component must have a root DOM element.
    return <div />;
  }
}

customElements.define(`mp-react-snabbdom-renderer`, ReactSnabbdomRenderer);
